import { getRequest, postRequest, URL } from "shared/utils";
import * as types from "./actionTypes";

const queryParms = (request) => {
  const {
    clientId,
    pageNumber,
    pageSize,
    sortColumn,
    sortDirection,
    searchKeyword,
    noticeDateStart,
    noticeDateEnd,
    filters,
  } = request;

  let parms = `?clientId=${clientId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

  if (sortColumn) {
    parms += `&sortColumn=${sortColumn}&sortDirection=${sortDirection}`;
  }

  if (searchKeyword) {
    parms += `&searchKeyword=${searchKeyword}`;
  }

  if (noticeDateStart && noticeDateEnd) {
    parms += `&noticeDateStart=${noticeDateStart}&noticeDateEnd=${noticeDateEnd}`;
  }

  if (filters) {
    Object.keys(filters).forEach((key, index) => {
      var filterBy = filters[key];

      if (filterBy && filterBy.length > 0) {
        filterBy.forEach((f) => {
          parms += `&${key}=${f}`;
        });
      }
    });
  }

  return parms;
};

export function getProperties(requestWithParams) {
  const url = `${URL.property}/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTIES,
    payload: request,
  };
}

export function getPropertySpreadsheet(parms) {
  var utcOffset = new Date().getTimezoneOffset() / 60;

  utcOffset = utcOffset * -1;

  let url = `${URL.property}/spreadsheet`;

  const { filters } = parms;

  delete parms.filters;

  for (var prop in filters) {
    if (Array.isArray(filters[prop]) && filters[prop].length === 0)
      delete filters[prop];
  }

  const request = postRequest(
    url,
    { ...parms, ...filters, utcOffset },
    false,
    "blob"
  );

  return {
    type: types.GET_PROPERTY_SPREADSHEET,
    payload: request,
  };
}

export function getProperty(id) {
  const url = `${URL.property}/${id}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY,
    payload: request,
  };
}

export function getPropertiesByIds(ids) {
  let url = `${URL.property}/ids?ids=${ids[0]}`; // ?ids=${id}`;

  if (ids.length > 1) {
    let idParms = "";

    ids.slice(1).forEach((id) => (idParms += `&ids=${id}`));

    url += idParms;
  }

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_BY_IDS,
    payload: request,
  };
}

export function getPropertyFilterOptions(clientId) {
  const url = `${URL.property}/filterOptions?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_FILTER_OPTIONS,
    payload: request,
  };
}

export function getPropertyNames(clientId) {
  const url = `${URL.property}/names?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_NAMES,
    payload: request,
  };
}

export function getPropertyCities(clientId) {
  const url = `${URL.property}/cities?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_CITIES,
    payload: request,
  };
}

export function getPropertyStateProvinces(clientId) {
  const url = `${URL.property}/states?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_STATE_PROVINCES,
    payload: request,
  };
}

export function getPropertyCountries(clientId) {
  const url = `${URL.property}/countries?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_COUNTRIES,
    payload: request,
  };
}

export function getPropertyCampusFacilities(clientId) {
  const url = `${URL.property}/campus-facilities?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_CAMPUS_FACILITIES,
    payload: request,
  };
}

export function getPropertyTypes(clientId) {
  const url = `${URL.property}/types?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_TYPES,
    payload: request,
  };
}

export function getPropertyStatuses(clientId) {
  const url = `${URL.property}/statuses?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTY_STATUSES,
    payload: request,
  };
}

export function getDistinctClientRegions(clientId) {
  const url = `${URL.property}/regions?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_DISTINCT_CLIENT_REGIONS,
    payload: request,
  };
}

export function getAssociatedLeases(clientId, propertyId) {
  const url = `${URL.property}/leases?clientId=${clientId}&propertyId=${propertyId}`;

  const request = getRequest(url);

  return {
    type: types.GET_ASSOCIATED_LEASE,
    payload: request,
  };
}

export function getAllProperties(requestWithParams) {
  const url = `${URL.property}/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_ALL_PROPERTIES,
    payload: request,
  };
}

export function getPropertyPageSize(userId, tableName) {
  const url = `${URL.property}/pageSize?userId=${userId}&tableName=${tableName}`;

  const request = getRequest(url);

  return {
    type: types.GET_PROPERTIES_PAGE_SIZE,
    payload: request,
  };
}